export default __webpack_public_path__ + "static/media/baner2.2d40e8a4.jpg";